import { AppFeedbackRequestData, UploadedFile, UploadFeedbackFile } from '@shared/models/feedback';
import { baseQueryWithMsalAuth } from './baseApi';
import { createApi } from "@reduxjs/toolkit/query/react";

const controllerName = '/chat'

export const chatsApi = createApi({
  reducerPath: 'chatsApi',
  baseQuery: baseQueryWithMsalAuth,
  endpoints: (builder) => ({
    uploadFeedbackFile: builder.mutation<UploadedFile, UploadFeedbackFile>({
      async queryFn({ file }, _api, _extra, baseQuery) {
        const formData = new FormData();
        formData.append('file', file);

        const result = await baseQuery({
          url: `${controllerName}/feedback/upload_file`,
          method: 'POST',
          body: formData,
        });

        if (result.error) {
          return { error: result.error };
        }

        return { data: result.data as UploadedFile };
      },
    }),
    sendAppFeedback: builder.mutation<string, AppFeedbackRequestData>({
      query: (data) => ({
        url: `${controllerName}/feedback/rate`,
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export const {
  useUploadFeedbackFileMutation,
  useSendAppFeedbackMutation,
} = chatsApi;


// export const feedbackUploadFileRequest = async (file: File, token: string): Promise<UploadedFile> => {
//   return { url: '', filename: '' };
//   // const formData = new FormData();
//   // formData.append('file', file);

//   // return await requestCreator<FormData, UploadedFile>(
//   //   'POST',
//   //   `${controllerName}/feedback/upload_file`,
//   //   token,
//   //   formData,
//   //   {
//   //     'Content-Type': 'multipart/form-data',
//   //   },
//   //   undefined,
//   //   'File upload failed.',
//   // );
// };

// export const appFeedbackRequest = async (data: AppFeedbackRequestData, token: string): Promise<string> =>
//   "";
// // await requestCreator<AppFeedbackRequestData, string>(
// //   'POST',
// //   `${controllerName}/feedback/rate`,
// //   token,
// //   data,
// //   undefined,
// //   undefined,
// //   'Feedback sending failed.',
// // );
